module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.012cf6a1.woff";